import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import { push } from 'react-router-redux'

import * as actions from './actions'
import * as asyncActions from './actionsAsync'
import * as selectors from './selectors'
import { userCreateModalShow } from 'Global/Stores/modals'

const UsersModuleHOC = WrappedComponent => {
  class UsersModuleHOC extends Component {
    static propTypes = {
      createdUser: PropTypes.number,
      errors: PropTypes.object.isRequired,
      getUsers: PropTypes.func.isRequired,
      pendings: PropTypes.object.isRequired,
      redirectToNewUser: PropTypes.func.isRequired,
      setSortBy: PropTypes.func.isRequired,
      setSortOrder: PropTypes.func.isRequired,
      showCreateUserModal: PropTypes.func.isRequired,
      sortBy: PropTypes.string.isRequired,
      sortOrder: PropTypes.string.isRequired,
      users: PropTypes.array.isRequired,
    }

    componentDidMount() {
      const { getUsers, users } = this.props

      if (users.length === 0) {
        getUsers()
      }
    }

    componentDidUpdate() {
      const { createdUser, redirectToNewUser } = this.props

      if (createdUser) {
        redirectToNewUser(createdUser)
      }
    }

    render() {
      const { errors, pendings, users } = this.props

      return (
        <WrappedComponent hasError={errors.getUsers} loaderPending={pendings.getUsers && !errors.getUsers} users={users} {...this.props} />
      )
    }
  }

  const mapStateToProps = (state, ownProps) => ({
    createdUser: selectors.createdUser(state),
    errors: selectors.errors(state),
    pendings: selectors.pendings(state),
    sortBy: selectors.sortBy(state),
    sortOrder: selectors.sortOrder(state),
    users: selectors.sortedUsers(state),
  })

  const mapDispatchToProps = (dispatch, ownProps) => ({
    getUsers: () => dispatch(asyncActions.getUsers()),
    redirectToNewUser: id => dispatch(push(`/user/${id}`)),
    setSortBy: column => dispatch(actions.setSortBy(column)),
    setSortOrder: order => dispatch(actions.setSortOrder(order)),
    showCreateUserModal: () => dispatch(userCreateModalShow()),
  })

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(UsersModuleHOC)
}

export default UsersModuleHOC
